"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Savvy = exports.SavParser = exports.Feeder = void 0;
/**
 * An object that stores an {@link ArrayBuffer} and returns subsequent portions on demand
 */

var Feeder = /*#__PURE__*/function () {
  /**
   *
   * @param buffer An {@link ArrayBuffer} that will be fed out by the object
   */
  function Feeder(buffer) {
    _classCallCheck(this, Feeder);

    this.buffer = buffer;
    this.cursor = 0;
  }
  /**
   * Jump the cursor to a position in the buffer.
   * @param position the position in the {@link ArrayBuffer} to jump to
   */


  _createClass(Feeder, [{
    key: "jump",
    value: function jump(position) {
      if (position < 0 || position > this.buffer.byteLength) {
        throw new Error('Jump to out-of-bounds position');
      }

      this.cursor = position;
    }
    /**
     * Get the next chunk of the ArrayBuffer from the current cursor position
     * and move the cursor.
     * @param size the number of bytes to read from the {@link ArrayBuffer}
     * @returns an {@link ArrayBuffer} of the requested `size` from the cursor position
     */

  }, {
    key: "next",
    value: function next(size) {
      if (!this.buffer || this.cursor + size > this.buffer.byteLength) {
        throw new Error('Unexpected End of File');
      } else {
        this.cursor += size;
        return this.buffer.slice(this.cursor - size, this.cursor);
      }
    }
    /**
     * Get the current position of the cursor
     * @returns the current cursor position as a number
     */

  }, {
    key: "position",
    value: function position() {
      return this.cursor;
    }
    /**
     * Check whether the {@link ArrayBuffer} has been exhausted
     * @returns a boolean, whether the {@link ArrayBuffer} is exhausted
     */

  }, {
    key: "done",
    value: function done() {
      return this.cursor === this.buffer.byteLength;
    }
  }]);

  return Feeder;
}();

exports.Feeder = Feeder;

var DataReader = /*#__PURE__*/function () {
  function DataReader(schema, feeder) {
    var log = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, DataReader);

    this.feeder = feeder;
    this.position = feeder.position();
    this.cursor = 8;
    this.schema = schema;
    this.decoder = new TextDecoder();
    this.log = log;
  }

  _createClass(DataReader, [{
    key: "compressedCodes",
    value: function compressedCodes() {
      var instruction;

      do {
        if (this.cursor > 7) {
          this.instructions = new DataView(this.feeder.next(8));
          this.cursor = 0;
        }

        instruction = this.instructions.getUint8(this.cursor++);
      } while (instruction === 0);

      return instruction;
    }
  }, {
    key: "uncompressedNumber",
    value: function uncompressedNumber() {
      return new DataView(this.feeder.next(8)).getFloat64(0, this.schema.internal.integer.endianness === 2);
    }
  }, {
    key: "uncompressedString",
    value: function uncompressedString(length) {
      var pieces = [];

      do {
        pieces.concat(this.decoder.decode(this.feeder.next(8)));
      } while (--length);

      return pieces.join('');
    }
  }, {
    key: "compressedNumber",
    value: function compressedNumber() {
      var code = this.compressedCodes();

      switch (code) {
        case 252:
          throw new Error('Unexpected end of records.');

        case 253:
          return new DataView(this.feeder.next(8)).getFloat64(0, true);

        case 254:
          throw new Error('Cell code type mismatch');

        case 255:
          return null;

        default:
          return code - this.schema.meta.bias;
      }
    }
  }, {
    key: "compressedString",
    value: function compressedString(length) {
      var pieces = [];

      do {
        var code = this.compressedCodes();

        switch (code) {
          case 252:
            throw new Error('Unexpected end of records.');

          case 253:
            pieces.push(this.decoder.decode(this.feeder.next(8)));
            break;

          case 254:
            pieces.push('');
            break;

          case 255:
            return null;

          default:
            throw new Error('Default code not supported for strings.');
        }
      } while (--length);

      return pieces.join('');
    }
  }, {
    key: "readNumber",
    value: function readNumber() {
      if (this.schema.meta.compression) {
        return this.compressedNumber();
      } else {
        return this.uncompressedNumber();
      }
    }
  }, {
    key: "readString",
    value: function readString(length) {
      if (this.schema.meta.compression) {
        return this.compressedString(length);
      } else {
        return this.uncompressedString(length);
      }
    }
  }, {
    key: "readCell",
    value: function readCell(header) {
      this.log.push('Cell: ' + header.name);

      if (header.code) {
        return this.readString(Math.ceil(header.code / 8));
      } else {
        return this.readNumber();
      }
    }
  }, {
    key: "readRow",
    value: function readRow() {
      var _this = this;

      return new Map(this.schema.headers.map(function (header) {
        return [header.name, _this.readCell(header)];
      }));
    }
  }, {
    key: "read",
    value: function read() {
      var _this2 = this;

      this.feeder.jump(this.schema.internal.finished);
      var readArray = new Array(this.schema.meta.cases).fill(0).map(function (_, idx) {
        _this2.log.push('Row: ' + idx);

        return _this2.readRow();
      });
      this.feeder.jump(this.position);
      return readArray;
    }
  }]);

  return DataReader;
}();
/**
 * A parser for .sav files
 */


var SavParser = /*#__PURE__*/function () {
  /**
   * Create a new parser
   * @param log a string array that will be populated by parse calls
   */
  function SavParser() {
    var log = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, SavParser);

    this.decoder = new TextDecoder();
    this.log = log;
  }

  _createClass(SavParser, [{
    key: "readFieldLabel",
    value: function readFieldLabel(feeder) {
      var length = new DataView(feeder.next(4)).getInt32(0, true);

      if (length % 4) {
        length = length + (4 - length % 4);
      }

      return this.decoder.decode(feeder.next(length)).trim();
    }
  }, {
    key: "readFieldMissingCodes",
    value: function readFieldMissingCodes(view, count) {
      var readArray = new Array(count).fill(0);
      return readArray.map(function (_, idx) {
        return view.getFloat64(8 * idx);
      });
    }
  }, {
    key: "readFieldMissingStrings",
    value: function readFieldMissingStrings(chunk, count) {
      var _this3 = this;

      var readArray = new Array(count).fill(0);
      return readArray.map(function (_, idx) {
        return _this3.decoder.decode(chunk.slice(8 * idx, 8 * idx + 8));
      });
    }
  }, {
    key: "readFieldMissingRange",
    value: function readFieldMissingRange(view) {
      return [view.getFloat64(0, true), view.getFloat64(8, true)];
    }
  }, {
    key: "readFieldMissing",
    value: function readFieldMissing(feeder, numeric, code) {
      var chunk = feeder.next(8 * Math.abs(code));
      var view = new DataView(chunk);
      return {
        codes: numeric && code > 0 ? this.readFieldMissingCodes(view, code) : numeric && code === -3 ? this.readFieldMissingCodes(view, 3).slice(2) : [],
        range: numeric && code < 0 ? this.readFieldMissingRange(view) : [undefined, undefined],
        strings: !numeric && code > 0 ? this.readFieldMissingStrings(chunk, code) : []
      };
    }
  }, {
    key: "readField",
    value: function readField(feeder) {
      this.log.push('Reading Field at ' + feeder.position());
      var start = feeder.position();
      var chunk = feeder.next(28);
      var view = new DataView(chunk);
      var code = view.getInt32(0, true);
      var labeled = view.getInt32(4, true);
      var missings = view.getInt32(8, true);
      var name = this.decoder.decode(chunk.slice(20, 28)).trim();
      var label = labeled ? this.readFieldLabel(feeder) : '';
      var missing = missings ? this.readFieldMissing(feeder, code === 0, missings) : {
        codes: [],
        range: [undefined, undefined],
        strings: []
      };
      return {
        start: start,
        code: code,
        name: name,
        label: label,
        missing: missing,
        trailers: 0
      };
    }
  }, {
    key: "getLevel",
    value: function getLevel(feeder) {
      this.log.push('Scale level at ' + feeder.position());
      var view = new DataView(feeder.next(9));
      var length = view.getInt8(8);
      var size = (length + 1) % 8 ? length + (8 - (length + 1) % 8) : length;
      return [view.getFloat64(0, true), this.decoder.decode(feeder.next(size)).substring(0, length).trim()];
    }
  }, {
    key: "readScale",
    value: function readScale(feeder) {
      var _this4 = this;

      this.log.push('Scale definition at ' + feeder.position());
      var count = new DataView(feeder.next(4)).getInt32(0, true);
      var readArray = new Array(count).fill(0);
      var levels = new Map(readArray.map(function () {
        return _this4.getLevel(feeder);
      }));
      var view = new DataView(feeder.next(8));
      var magic = view.getInt32(0, true);
      var icount = view.getInt32(4, true);

      if (magic !== 4) {
        throw new Error('Levels read error. ' + 'Magic value Expected: 4 ' + 'Actual: ' + magic);
      }

      var iview = new DataView(feeder.next(4 * icount));
      var indices = new Set(new Array(icount).fill(0).map(function (_, idx) {
        return iview.getInt32(idx * 4, true);
      }));
      return {
        map: levels,
        indices: indices
      };
    }
  }, {
    key: "readDocument",
    value: function readDocument(feeder) {
      var _this5 = this;

      this.log.push('Sys Document at ' + feeder.position());
      var count = new DataView(feeder.next(4)).getInt32(0, true);
      var chunk = feeder.next(count * 80);
      var docArray = new Array(count).fill(0);
      return docArray.map(function (_, idx) {
        return _this5.decoder.decode(chunk.slice(idx * 80, idx * 80 + 80));
      });
    }
  }, {
    key: "readSysInteger",
    value: function readSysInteger(feeder) {
      this.log.push('Sys Integer at ' + feeder.position());
      var view = new DataView(feeder.next(32));
      return {
        major: view.getInt32(0, true),
        minor: view.getInt32(4, true),
        revision: view.getInt32(8, true),
        machine: view.getInt32(12, true),
        "float": view.getInt32(16, true),
        compression: view.getInt32(20, true),
        endianness: view.getInt32(24, true),
        character: view.getInt32(28, true)
      };
    }
  }, {
    key: "readSysFloat",
    value: function readSysFloat(feeder) {
      this.log.push('Sys Float at ' + feeder.position());
      var view = new DataView(feeder.next(24));
      return {
        missing: view.getFloat64(0, true),
        high: view.getFloat64(8, true),
        low: view.getFloat64(16, true)
      };
    }
  }, {
    key: "readSysDisplay",
    value: function readSysDisplay(feeder, count) {
      this.log.push('Sys Display at ' + feeder.position());
      var view = new DataView(feeder.next(count * 12));
      var dispArray = new Array(count).fill(0);
      return dispArray.map(function (_, idx) {
        return {
          type: view.getInt32(idx * 12, true),
          width: view.getInt32(idx * 12 + 4, true),
          align: view.getInt32(idx * 12 + 8, true)
        };
      });
    }
  }, {
    key: "readNames",
    value: function readNames(feeder, size) {
      this.log.push('Names at ' + feeder.position());
      var raw = this.decoder.decode(feeder.next(size));
      return new Map(raw.split('\t').map(function (str) {
        return str.split('=');
      }));
    }
  }, {
    key: "readLongWidths",
    value: function readLongWidths(feeder, size) {
      this.log.push('Long Widths at ' + feeder.position());
      var raw = this.decoder.decode(feeder.next(size));
      var rows = raw.split('\t');
      return new Map(rows.slice(0, rows.length - 1).map(function (str) {
        return str.split('=');
      }).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            length = _ref2[1];

        return [name, parseInt(length, 10)];
      }));
    }
  }, {
    key: "readLongNames",
    value: function readLongNames(feeder, size) {
      this.log.push('Long Names at ' + feeder.position()); // need to figure out how this works

      return feeder.next(size);
    }
  }, {
    key: "readUnrecognized",
    value: function readUnrecognized(feeder, count, length) {
      var chunk = feeder.next(count * length);
      var readArray = new Array(count).fill(0);
      return readArray.map(function (_, idx) {
        return chunk.slice(idx * length, idx * length + length);
      });
    }
  }, {
    key: "readInternal",
    value: function readInternal(feeder) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;

      this.log.push('Reading Internal');
      var partial = {};
      var code;
      var subcode;
      var subview;
      var length;
      var count;

      while (!partial.finished) {
        code = new DataView(feeder.next(4)).getInt32(0, true);

        switch (code) {
          case 3:
            partial.levels = ((_a = partial.levels) !== null && _a !== void 0 ? _a : []).concat(this.readScale(feeder));
            break;

          case 6:
            partial.documents = ((_b = partial.documents) !== null && _b !== void 0 ? _b : []).concat(this.readDocument(feeder));
            break;

          case 7:
            subview = new DataView(feeder.next(12));
            subcode = subview.getInt32(0, true);
            length = subview.getInt32(4, true);
            count = subview.getInt32(8, true);

            switch (subcode) {
              case 3:
                this.log.push('Subcode 3');

                if (length * count !== 32) {
                  throw new Error('Special code 3 ' + 'Expected: 32 bytes; ' + 'Actual: ' + length * count);
                }

                partial.integer = this.readSysInteger(feeder);
                break;

              case 4:
                this.log.push('Subcode 4');

                if (length * count !== 24) {
                  throw new Error('Special code 4 ' + 'Expected: 24 bytes; ' + 'Actual: ' + length * count);
                }

                partial["float"] = this.readSysFloat(feeder);
                break;

              case 11:
                this.log.push('Subcode 11');

                if (length !== 4) {
                  throw new Error('Special code 11 ' + 'Expected: 4 bytes; ' + 'Actual: ' + length);
                }

                if (count % 3) {
                  throw new Error('Special code 11 ' + 'Expected: Length factor of 3; ' + 'Actual: ' + length);
                }

                partial.display = ((_c = partial.display) !== null && _c !== void 0 ? _c : []).concat(this.readSysDisplay(feeder, count / 3));
                break;

              case 13:
                this.log.push('Subcode 13');
                partial.names = new Map([].concat(_toConsumableArray((_d = partial.names) !== null && _d !== void 0 ? _d : []), _toConsumableArray(this.readNames(feeder, count * length))));
                break;

              case 14:
                this.log.push('Subcode 14');
                partial.longs = new Map([].concat(_toConsumableArray((_e = partial.longs) !== null && _e !== void 0 ? _e : []), _toConsumableArray(this.readLongWidths(feeder, count * length))));
                break;

              case 21:
                this.log.push('Subcode 21');
                partial.extra = ((_f = partial.extra) !== null && _f !== void 0 ? _f : []).concat(this.readLongNames(feeder, count * length));
                break;

              default:
                this.log.push('Unrecognized Subcode');
                partial.unrecognized = ((_g = partial.unrecognized) !== null && _g !== void 0 ? _g : []).concat([[subcode, this.readUnrecognized(feeder, count, length)]]);
                break;
            }

            break;

          case 999:
            feeder.next(4);
            partial.finished = feeder.position();
            break;

          default:
            throw new Error('Internal Code Expected : [3, 6, 7, 999]; Actual : ' + code);
        }
      }

      return {
        "float": (_h = partial["float"]) !== null && _h !== void 0 ? _h : {
          missing: undefined,
          high: undefined,
          low: undefined
        },
        integer: (_j = partial.integer) !== null && _j !== void 0 ? _j : {
          major: undefined,
          minor: undefined,
          revision: undefined,
          machine: undefined,
          "float": undefined,
          compression: undefined,
          endianness: undefined,
          character: undefined
        },
        display: (_k = partial.display) !== null && _k !== void 0 ? _k : [],
        documents: (_l = partial.documents) !== null && _l !== void 0 ? _l : [],
        names: (_m = partial.names) !== null && _m !== void 0 ? _m : new Map(),
        longs: (_o = partial.longs) !== null && _o !== void 0 ? _o : new Map(),
        levels: (_p = partial.levels) !== null && _p !== void 0 ? _p : [],
        extra: (_q = partial.extra) !== null && _q !== void 0 ? _q : [],
        unrecognized: (_r = partial.unrecognized) !== null && _r !== void 0 ? _r : [],
        finished: partial.finished
      };
    }
  }, {
    key: "readFields",
    value: function readFields(feeder) {
      this.log.push('Reading Field at ' + feeder.position());
      var code;
      var fields = [];
      var field;

      while (true) {
        code = new DataView(feeder.next(4)).getInt32(0, true);

        if (code !== 2) {
          feeder.jump(feeder.position() - 4);
          break;
        }

        field = this.readField(feeder);

        if (field.code > -1) {
          fields.push(field);
        } else {
          fields[fields.length - 1].trailers++;
        }
      }

      return fields;
    }
    /**
     * Read the meta fields from a .sav file
     * @param feeder A {@link Feeder} object encoding the sav file
     * @remarks
     * From a node.js {@link Buffer} using `fs.readFile`
     * ```
     * fs = require('fs');
     *
     * let meta;
     * const parser = new SavParser()
     * // with async readFile
     * fs.readFile('some/path/to/file.sav', (err, data) => {
     *     parser.meta(new Feeder(data.buffer)).then(
     *         result => meta = result
     *     )
     * });
     * // with syncronous readFileSync
     * parser.meta(
     *     new Feeder(fs.readFileSync('/some/path/to/file.sav').buffer)
     * ).then(
     *     parsed => meta = parsed
     * );
     * ```
     *
     * In the browser with a File API
     * ```
     *     <input type="file" onchange = "onChange(event)"></input>
     * ```
     * ```
     * const meta;
     * function onChange(event){
     *     const file = event.target.files[0];
     *     const reader = new FileReader();
     *     const parser = new SavParser();
     *     reader.onload = function(data){
     *         data.arrayBuffer().then(
     *             buffer => parser.meta(new Feeder(buffer))
     *         ).then(
     *             parsed => meta = parsed
     *         );
     *     }
     *     reader.readAsArrayBuffer(file);
     * }
     * ```
     * @return A promise resolving with a {@link Meta} object
     */

  }, {
    key: "meta",
    value: function meta(feeder) {
      var _this6 = this;

      this.log.splice(0, this.log.length);
      var position = feeder.position();
      feeder.jump(0);
      return new Promise(function (resolve, reject) {
        var chunk = feeder.next(176);
        var view = new DataView(chunk);

        var magic = _this6.decoder.decode(chunk.slice(0, 4));

        if (magic !== '$FL2') {
          reject(new Error('File is not a sav. ' + 'Magic key Expected: "$FL2"; ' + 'Actual: ' + magic));
        }

        resolve({
          product: _this6.decoder.decode(chunk.slice(4, 64)).trim(),
          layout: view.getInt32(64, true),
          variables: view.getInt32(68, true),
          compression: view.getInt32(72, true),
          weightIndex: view.getInt32(76, true),
          cases: view.getInt32(80, true),
          bias: view.getFloat64(84, true),
          createdDate: _this6.decoder.decode(chunk.slice(92, 101)),
          createdTime: _this6.decoder.decode(chunk.slice(101, 109)),
          label: _this6.decoder.decode(chunk.slice(109, 173)).trim()
        });
      })["finally"](function () {
        return feeder.jump(position);
      });
    }
    /**
     * Read the column header fields from a .sav file.
     * Header here refers to the head of the columns of the data, i.e.
     * properties of the variables in the data file
     * @param feeder A {@link Feeder} object encoding the sav file
     * @remarks
     * From a node.js {@link Buffer} using `fs.readFile`
     * ```
     * fs = require('fs');
     *
     * let headers;
     * const parser = new SavParser()
     * // with async readFile
     * fs.readFile('some/path/to/file.sav', (err, data) => {
     *     parser.headers(new Feeder(data.buffer)).then(
     *         result => headers = result
     *     )
     * });
     * // with syncronous readFileSync
     * parser.headers(
     *     new Feeder(fs.readFileSync('/some/path/to/file.sav').buffer)
     * ).then(
     *     parsed => headers = parsed
     * );
     * ```
     *
     * In the browser with a File API
     * ```
     *     <input type="file" onchange = "onChange(event)"></input>
     * ```
     * ```
     * const headers;
     * function onChange(event){
     *     const file = event.target.files[0];
     *     const reader = new FileReader();
     *     const parser = new SavParser();
     *     reader.onload = function(data){
     *         data.arrayBuffer().then(
     *             buffer => parser.headers(new Feeder(buffer))
     *         ).then(
     *             parsed => headers = parsed
     *         );
     *     }
     *     reader.readAsArrayBuffer(file);
     * }
     * ```
     * @return A promise resolving with an Array<{@link Meta}> object
     */

  }, {
    key: "headers",
    value: function headers(feeder) {
      this.log.splice(0, this.log.length);
      var position = feeder.position();
      feeder.jump(176);
      return Promise.resolve(this.readFields(feeder))["finally"](function () {
        return feeder.jump(position);
      });
    }
    /**
     * Read all schema fields from a .sav file.
     * Schema here refers to all information except for the data cells themselves
     * @param feeder A {@link Feeder} object encoding the sav file
     * @remarks
     * From a node.js {@link Buffer} using `fs.readFile`
     * ```
     * fs = require('fs');
     *
     * let schema;
     * const parser = new SavParser()
     * // with async readFile
     * fs.readFile('some/path/to/file.sav', (err, data) => {
     *     parser.schema(new Feeder(data.buffer)).then(
     *         result => schema = result
     *     )
     * });
     * // with syncronous readFileSync
     * parser.schema(
     *     new Feeder(fs.readFileSync('/some/path/to/file.sav').buffer)
     * ).then(
     *     parsed => schema = parsed
     * );
     * ```
     *
     * In the browser with a File API
     * ```
     *     <input type="file" onchange = "onChange(event)"></input>
     * ```
     * ```
     * const schema;
     * function onChange(event){
     *     const file = event.target.files[0];
     *     const reader = new FileReader();
     *     const parser = new SavParser();
     *     reader.onload = function(data){
     *         data.arrayBuffer().then(
     *             buffer => parser.schema(new Feeder(buffer))
     *         ).then(
     *             parsed => schema = parsed
     *         );
     *     }
     *     reader.readAsArrayBuffer(file);
     * }
     * ```
     * @return A promise resolving with an {@link Schema} object
     */

  }, {
    key: "schema",
    value: function schema(feeder) {
      var _this7 = this;

      this.log.splice(0, this.log.length);
      var position = feeder.position();
      return this.meta(feeder).then(function (meta) {
        return {
          meta: meta
        };
      }).then(function (partial) {
        feeder.jump(176);
        return _objectSpread(_objectSpread({}, partial), {}, {
          headers: _this7.readFields(feeder)
        });
      }).then(function (partial) {
        return _objectSpread(_objectSpread({}, partial), {}, {
          internal: _this7.readInternal(feeder)
        });
      })["finally"](function () {
        return feeder.jump(position);
      });
    }
    /**
     * Read all fields from a .sav file.
     * All fields include the full {@link Schema} and all data cells as an
     * Array<{@link Row}.
     * @param feeder A {@link Feeder} object encoding the sav file
     * @remarks
     * From a node.js {@link Buffer} using `fs.readFile`
     * ```
     * fs = require('fs');
     *
     * let all;
     * const parser = new SavParser()
     * // with async readFile
     * fs.readFile('some/path/to/file.sav', (err, data) => {
     *     parser.all(new Feeder(data.buffer)).then(
     *         result => all = result
     *     )
     * });
     * // with syncronous readFileSync
     * parser.all(
     *     new Feeder(fs.readFileSync('/some/path/to/file.sav').buffer)
     * ).then(
     *     parsed => all = parsed
     * );
     * ```
     *
     * In the browser with a File API
     * ```
     *     <input type="file" onchange = "onChange(event)"></input>
     * ```
     * ```
     * const all;
     * function onChange(event){
     *     const file = event.target.files[0];
     *     const reader = new FileReader();
     *     const parser = new SavParser();
     *     reader.onload = function(data){
     *         data.arrayBuffer().then(
     *             buffer => parser.all(new Feeder(buffer))
     *         ).then(
     *             parsed => all = parsed
     *         );
     *     }
     *     reader.readAsArrayBuffer(file);
     * }
     * ```
     * @return A promise resolving with an {@link Parsed} object
     */

  }, {
    key: "all",
    value: function all(feeder) {
      var _this8 = this;

      this.log.splice(0, this.log.length);
      var position = feeder.position();
      return this.schema(feeder).then(function (schema) {
        return _objectSpread(_objectSpread({}, schema), {}, {
          rows: new DataReader(schema, feeder, _this8.log).read()
        });
      })["finally"](function () {
        return feeder.jump(position);
      });
    }
  }]);

  return SavParser;
}();

exports.SavParser = SavParser;

var dataset_1 = require("./dataset");

Object.defineProperty(exports, "Savvy", {
  enumerable: true,
  get: function get() {
    return dataset_1.Savvy;
  }
});